import React from 'react'

const Logo = () => {
  return (
    <div className='w-full flex justify-center'>
<div class="ui-abstergo">
  <div class="abstergo-loader">
    <div></div>
    <div></div>
    <div></div>
  </div>
  <div class="ui-text">
  MIND LOOP
  </div>
</div>
    </div>
  )
}

export default Logo
